import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Layout from './Components/Layout';
import ProtectedRoute from './Components/ProtectedRoute';
import PublicRoute from './Components/PublicRoute';
import Login from './Screens/Login';
import UserRegister from './Screens/UserRegister';
import Dashboard from './Screens/Dashboard';
import Forget from './Screens/Forget';
import Resetpassword from './Screens/Resetpassword';
import SupplyMaster from "./Screens/SupplyMaster";
import SupplyMasterAdd from "./Screens/SupplyMasterAdd";
import SupplyMasterView from "./Screens/SupplyMasterView";
import SupplyMasterEdit from "./Screens/SupplyMasterEdit";
import User from "./Screens/User";
import UserAdd from "./Screens/UserAdd";
import UserView from "./Screens/UserView";
import UserEdit from "./Screens/UserEdit";
import Profile from "./Screens/Profile";
import SoConverter from "./Screens/SoConverter";
import SoValidate from "./Screens/SoValidate";
import SoData from "./Screens/SoData";
import SupplyMasterImport from "./Screens/SupplyMasterImport";
import TrackerAdd from "./Screens/TrackerAdd";
import TrackerEdit from "./Screens/TrackerEdit";
import TrackerUpdate from "./Screens/TrackerUpdate";
import TrackerView from "./Screens/TrackerView";
import TrackerUpdateAdd from "./Screens/TrackerUpdateAdd";
import ProcurementTracker from "./Screens/ProcurementTracker";
import ProcurementTrackerAdd from "./Screens/ProcurementTrackerAdd";
import ProcurementView from "./Screens/ProcurementView";
import ProcurementTrackerEdit from "./Screens/ProcurementTrackerEdit";
import PaymentTracker from "./Screens/PaymentTracker";
import PaymentTrackerAdd from "./Screens/PaymentTrackerAdd";
import PaymentTrackerEdit from "./Screens/PaymentTrackerEdit";
import PaymentTrackerView from "./Screens/PaymentTrackerView";
import RoleList from "./Screens/Role";
import CreateRole from "./Screens/RoleAdd";
import EditRole from "./Screens/RoleEdit";
import Task from "./Screens/Task";
import TaskAdd from "./Screens/TaskAdd";
import TaskView from "./Screens/TaskView";
import TaskEdit from "./Screens/TaskEdit";
import PriceTracker from "./Screens/PriceTracker";
import PriceTrackerAdd from "./Screens/PriceTrackerAdd";
import PriceTrackerEdit from "./Screens/PriceTrackerEdit";
import PriceTrackerView from "./Screens/PriceTrackerView";
import ProcurementTrackerImport from "./Screens/ProcurementTrackerImport";
import CustomerMaster from "./Screens/CustomerMaster";
import CustomerMasterAdd from "./Screens/CustomerMasterAdd";
import CustomerMasterEdit from "./Screens/CustomerMasterEdit";
import CustomerMasterView from "./Screens/CustomerMasterView";
import SalesTracker from "./Screens/SalesTracker";
import SalesTrackerAdd from "./Screens/SalesTrackerAdd";
import SalesTrackerView from "./Screens/SalesTrackerView";
import SalesTrackerEdit from "./Screens/SalesTrackerEdit";
import Rfq from "./Screens/Rfq";
import RfqCreate from "./Screens/RfqCreate";
import RfqView from "./Screens/RfqView";
import RfqSuppliers from "./Screens/RfqSuppliers";
import RfqComparison from "./Screens/RfqComparison";
import SalesQuotes from "./Screens/SalesQuotes";
import SalesQuotesAdd from "./Screens/SalesQuotesAdd";
import SalesQuotesEdit from "./Screens/SalesQuotesEdit";
import SalesQuotesView from "./Screens/SalesQuotesView";
import Category from "./Screens/Category";
import Subcategory from "./Screens/Subcategory";
import Po from "./Screens/Po";
import Pocreate from "./Screens/Pocreate";
import PoEdit from "./Screens/PoEdit";
import PoView from "./Screens/PoView";
import PoApprove from "./Screens/PoApprove";
import PoApproveView from "./Screens/PoApproveView";
import Material from "./Screens/Material";
import MaterialCreate from "./Screens/MaterialCreate";
import MaterialView from "./Screens/MaterialView";
import MaterialEdit from "./Screens/MaterialEdit";
import Inventory from "./Screens/Inventory";
import ListingLeads from "./Screens/ListingLeads";
import GoodsInwards from "./Screens/GoodsInwards";
import GoodsInwardsCreate from "./Screens/GoodsInwardsCreate";
import GoodsInwardsView from "./Screens/GoodsInwardsView";
import GoodsInwardsEdit from "./Screens/GoodsInwardsEdit";
import GoodsOutwards from "./Screens/GoodsOutwards";
import GoodsOutwardsCreate from "./Screens/GoodsOutwardsCreate";
import GoodsOutwardsView from "./Screens/GoodsOutwardsView";
import GoodsOutwardsEdit from "./Screens/GoodsOutwardsEdit";
import Ecatalogue from "./Screens/E-catalogue";
import EcatalogueView from "./Screens/E-catalogueView";
import EcatalogueEdit from "./Screens/E-catalogueEdit";
import Unit from "./Screens/Unit";
import Attribute from "./Screens/Attribute";
import AiChat from "./Screens/Ai-chat";
import TrackingPO from "./Screens/TrackingPO";
import SalesOrder from "./Screens/SalesOrder";
import SalesOrderCreate from "./Screens/SalesOrderCreate";
import SalesOrderView from "./Screens/SalesOrderView";
import SalesOrderImport from "./Screens/SalesOrderImport";
import Business from "./Screens/Business";
import { useDispatch } from "react-redux";
import { clearUser } from "./store/userSlice";
import { refreshSessionAccess } from "./utils/permissionSync";
import { clearLastAllowedPath } from "./Components/ModuleAccessGuard";
import { registerApiInterceptor } from './config/api';
import RfqSupplierList from "./Screens/Rfq-Supplier-List";
import RfqSupplierView from "./Screens/Rfq-Supplier-view";
import LrfqSupplierView from "./Screens/Lrfq-Supplier-view";
import FrightTracker from "./Screens/FrightTracker";
import FrightTrackerCreate from "./Screens/FrightTrackerCreate";
import FrightTrackerView from "./Screens/FrightTrackerView";
import FrightTrackerEdit from "./Screens/FrightTrackerEdit";
import PoSupplierList from "./Screens/po-supplier-list";
import PoSupplierView from "./Screens/po-supplier-view";
import GiSupplierList from "./Screens/gi-supplier-list";
import GiSupplierView from "./Screens/gi-supplier-view";
import CustomerSalesQuoteList from "./Screens/SalesQuote-customer-list";
import CustomerSalesQuoteView from "./Screens/SalesQuote-customer-view";
import CustomerSalesOrderList from "./Screens/SalesOrder-customer-list";
import CustomerSalesOrderView from "./Screens/SalesOrder-customer-view";
import LogisticsRfq from "./Screens/LogisticsRfq";
import LogisticsRfqCreate from "./Screens/LogisticsRfqCreate";
import LogisticsRfqComparison from "./Screens/LogisticsRfqComparison";
import LrfqView from "./Screens/LrfqView";


registerApiInterceptor();


function SessionWatcher() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const inFlightRef = useRef(false);
  const lastToastAtRef = useRef(0);

  useEffect(() => {
    let cancelled = false;

    const checkSession = async () => {
      const userId = localStorage.getItem("id");
      if (!userId || cancelled || inFlightRef.current) return;

      inFlightRef.current = true;
      try {
        const result = await refreshSessionAccess(dispatch, { silent: true });
        if (cancelled) return;

        if (result === "logout") {
          clearLastAllowedPath();
          dispatch(clearUser());
          toast.error("Your account has been deactivated.");
          navigate("/");
          return;
        }

        if (result === "updated") {
          const now = Date.now();
          // Avoid toast spam if several navigations refresh quickly
          if (now - lastToastAtRef.current > 2000) {
            lastToastAtRef.current = now;
            toast.info("Your permissions have been updated.");
          }
        }
      } finally {
        inFlightRef.current = false;
      }
    };

    // validate-session whenever the user is logged in / navigates / returns to tab
    checkSession();

    const onVisible = () => {
      if (document.visibilityState === "visible") checkSession();
    };

    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", checkSession);

    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", checkSession);
    };
  }, [navigate, dispatch, location.pathname]);

  return null;
}



function App() {
  return (
    <BrowserRouter>
      <SessionWatcher />
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>
        <Route path="/" element={<PublicRoute><ListingLeads /></PublicRoute>} />
        <Route path="/signin" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/forget" element={<PublicRoute><Forget /></PublicRoute>} />
        <Route path="/accept-invite" element={<PublicRoute><UserRegister /></PublicRoute>} />
        <Route path="/reset-password" element={<PublicRoute><Resetpassword /></PublicRoute>} />
        <Route path="/rfqSuppliers/:id/:supplierMailId/:supplierId?" element={<RfqSuppliers />} />
        <Route path="/lrfqSupplierView/:id/:supplierMailId/:supplierId?" element={<LrfqSupplierView />} />
        <Route path="/po-tracking" element={<TrackingPO />} />

        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/aiChat" element={<AiChat />} />
          <Route path="/supplyMaster" element={<SupplyMaster />} />
          <Route path="/supplyMasterAdd" element={<SupplyMasterAdd />} />
          <Route path="/supplyMasterImport" element={<SupplyMasterImport />} />
          <Route path="/supplyMasterView/:id" element={<SupplyMasterView />} />
          <Route path="/supplyMasterEdit/:id" element={<SupplyMasterEdit />} />
          <Route path="/user" element={<User />} />
          <Route path="/UserAdd" element={<UserAdd />} />
          <Route path="/userView/:id" element={<UserView />} />
          <Route path="/userEdit/:id" element={<UserEdit />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/soConverter" element={<SoConverter />} />
          <Route path="/soValidate" element={<SoValidate />} />
          <Route path="/sodata" element={<SoData />} />
          <Route path="/trackerAdd" element={<TrackerAdd />} />
          <Route path="/trackerUpdate" element={<TrackerUpdate />} />
          <Route path="/trackerUpdateAdd" element={<TrackerUpdateAdd />} />
          <Route path="/trackerEdit/:id" element={<TrackerEdit />} />
          <Route path="/trackerView/:id" element={<TrackerView />} />
          <Route path="/procurementTracker" element={<ProcurementTracker />} />
          <Route path="/procurementTrackerAdd" element={<ProcurementTrackerAdd />} />
          <Route path="/procurementView/:id" element={<ProcurementView />} />
          <Route path="/procurementTrackerEdit/:id" element={<ProcurementTrackerEdit />} />
          <Route path="/paymentTracker" element={<PaymentTracker />} />
          <Route path="/paymentTrackerAdd" element={<PaymentTrackerAdd />} />
          <Route path="/paymentView/:id" element={<PaymentTrackerView />} />
          <Route path="/paymentTrackerEdit/:id" element={<PaymentTrackerEdit />} />
          <Route path="/roles" element={<RoleList />} />
          <Route path="/roles/add" element={<CreateRole />} />
          <Route path="/roles/edit/:id" element={<EditRole />} />
          <Route path="/task" element={<Task />} />
          <Route path="/taskAdd" element={<TaskAdd />} />
          <Route path="/taskView/:id" element={<TaskView />} />
          <Route path="/taskEdit/:id" element={<TaskEdit />} />
          <Route path="/priceTracker" element={<PriceTracker />} />
          <Route path="/priceTrackerAdd" element={<PriceTrackerAdd />} />
          <Route path="/priceTrackerEdit/:id" element={<PriceTrackerEdit />} />
          <Route path="/priceTrackerView/:id" element={<PriceTrackerView />} />
          <Route path="/procurementTrackerImport" element={<ProcurementTrackerImport />} />
          <Route path="/customerMaster" element={<CustomerMaster />} />
          <Route path="/customerMasterAdd" element={<CustomerMasterAdd />} />
          <Route path="/customerMasterEdit/:id" element={<CustomerMasterEdit />} />
          <Route path="/customerMasterView/:id" element={<CustomerMasterView />} />
          <Route path="/salesTracker" element={<SalesTracker />} />
          <Route path="/salesTrackerAdd" element={<SalesTrackerAdd />} />
          <Route path="/salesTrackerView/:id" element={<SalesTrackerView />} />
          <Route path="/salesTrackerEdit/:id" element={<SalesTrackerEdit />} />
          <Route path="/rfq" element={<Rfq />} />
          <Route path="/rfqCreate" element={<RfqCreate />} />
          <Route path="/rfqCreate/:id" element={<RfqCreate />} />
          <Route path="/rfqView/:id" element={<RfqView />} />
          <Route path="/rfqComparison/:id" element={<RfqComparison />} />
          <Route path="/salesQuotes" element={<SalesQuotes />} />
          <Route path="/salesQuotesAdd" element={<SalesQuotesAdd />} />
          <Route path="/salesQuotesEdit/:id" element={<SalesQuotesEdit />} />
          <Route path="/salesQuotesView/:id" element={<SalesQuotesView />} />
          <Route path="/category" element={<Category />} />
          <Route path="/subcategory" element={<Subcategory />} />
          <Route path="/po" element={<Po />} />
          <Route path="/poCreate" element={<Pocreate />} />
          <Route path="/poEdit/:id" element={<PoEdit />} />
          <Route path="/poView/:id" element={<PoView />} />
          <Route path="/poApprove" element={<PoApprove />} />
          <Route path="/poApproveView/:id" element={<PoApproveView />} />
          <Route path="/material" element={<Material />} />
          <Route path="/materialCreate" element={<MaterialCreate />} />
          <Route path="/materialView/:id" element={<MaterialView />} />
          <Route path="/materialEdit/:id" element={<MaterialEdit />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/goodsInwards" element={<GoodsInwards />} />
          <Route path="/goodsInwardsCreate" element={<GoodsInwardsCreate />} />
          <Route path="/goodsInwardsView/:id" element={<GoodsInwardsView />} />
          <Route path="/goodsInwardsEdit/:id" element={<GoodsInwardsEdit />} />
          <Route path="/goodsOutwards" element={<GoodsOutwards />} />
          <Route path="/goodsOutwardsCreate" element={<GoodsOutwardsCreate />} />
          <Route path="/goodsOutwardsView/:id" element={<GoodsOutwardsView />} />
          <Route path="/goodsOutwardsEdit/:id" element={<GoodsOutwardsEdit />} />
          <Route path="/ecatalogue" element={<Ecatalogue />} />
          <Route path="/ecatalogueView/:id" element={<EcatalogueView />} />
          <Route path="/ecatalogueEdit/:id" element={<EcatalogueEdit />} />
          <Route path="/unit" element={<Unit />} />
          <Route path="/business" element={<Business/>}/>
          <Route path="/attribute" element={<Attribute />} />
          <Route path="/salesOrder" element={<SalesOrder />} />
          <Route path="/salesOrderCreate" element={<SalesOrderCreate />} />
          <Route path="/salesOrderCreate/:id" element={<SalesOrderCreate />} />
          <Route path="/salesOrderView/:id" element={<SalesOrderView />} />
          <Route path="/salesOrderImport" element={<SalesOrderImport />} />
          <Route path="/rfqSupplierList" element={<RfqSupplierList />} />
          <Route path="/rfqSupplierView/:id" element={<RfqSupplierView />} />
          <Route path="/frightTracker" element={<FrightTracker />} />
          <Route path="/frightTrackerCreate" element={<FrightTrackerCreate />} />
          <Route path="/frightTrackerView/:id" element={<FrightTrackerView />} />
          <Route path="/frightTrackerEdit/:id" element={<FrightTrackerEdit />} />
          <Route path="/poSupplierList" element={<PoSupplierList />} />
          <Route path="/poSupplierView/:id" element={<PoSupplierView />} />
          <Route path="/giSupplierList" element={<GiSupplierList />} />
          <Route path="/giSupplierView/:id" element={<GiSupplierView />} />
          <Route path="/customerSalesQuoteList" element={<CustomerSalesQuoteList />} />
          <Route path="/customerSalesQuoteView/:id" element={<CustomerSalesQuoteView />} />
          <Route path="/customerSalesOrderList" element={<CustomerSalesOrderList />} />
          <Route path="/customerSalesOrderView/:id" element={<CustomerSalesOrderView />} />
          <Route path="/logisticsRfq" element={<LogisticsRfq />} /> 
          <Route path="/logisticsRfqCreate" element={<LogisticsRfqCreate />} />
          <Route path="/logisticsRfqCreate/:id" element={<LogisticsRfqCreate />} /> 
          <Route path="/logisticsRfqComparison/:id" element={<LogisticsRfqComparison />} />
          <Route path="/logisticsRfqView/:id" element={<LrfqView />} />
        </Route>
      </Routes>
    </BrowserRouter>

  );
}

export default App;
